import Vue from "vue";
const printBus = new Vue();
export default printBus;
